export const testIdConstants = {
  globalCustomerSearch: "global-customer-search",
  customerNavigateToHeadAgreementButton:
    "customer-navigate-to-head-agreement-button",
  loginButton: "login-button",
  logOutButton: "log-out-button",
  userMenuButton: "user-menu-button",
  navBar: "nav-bar",
  menuLinkRouteTargets: "menu-link-route-targets",
  menuLinkNegotiationPlan: "menu-link-negotiation-plan",
  menuLinkStatistics: "menu-link-statistics",
  menuLinkPriceCalculator: "menu-link-price-calculator",
  menuLinkNSLH: "menu-link-nslh",
  menuLinkNSLHRoutePrices: "menu-link-nslh-route-prices",
  menuLinkNSLHHandleBookings: "menu-link-nslh-handle-bookings",
  menuLinkNSLHFollowUp: "menu-link-nslh-follow-up",
  menuLinkAdminGroupFreightTargets: "menu-link-admin-group-freight-targets",
  menuLinkAdminUploadSurchargeDocuments:
    "menu-link-admin-upload-surcharge-documents",
  raiseTypeSelect: "raise-type-select",
  numberDecimalsSelect: "number-decimals-select",
  raiseByTypeSelect: "raise-by-type-select",
  filterSearchButton: "filter-search-button",
  routeFilterSection: "route-filter-section",
  routeFilterSectionSeaAreaCollapsible:
    "route-filter-section-sea-area-collapsible",
  routeFilterSectionCheckboxList: "route-filter-section-checkbox-list",
  statisticsNegotiationYearSelect: "negotiation-year-select",
  statisticsTotalCustomersResult: "statistics-total-customers-result",
  statisticsTotalVolumeResult: "statistics-total-volume-result",
  statisticsTotalByCustomerByStatus: "statistics-total-by-customer-by-status",
  statisticsTotalByVolumeByStatus: "statistics-total-by-volume-by-status",
  statisticsSalesRegionResultTable: "statistics-sales-region-result-table",
  routeTargetsOverviewNegotiationYear:
    "route-targets-overview-negotiation-year",
  negotiationPlanTotalCustomersResult:
    "negotiation-plan-total-customers-result",
  priceCalculatorSearchFieldHeader: "price-calculator-search-field-header",
  priceCalculatorCustomerOrBookingBox:
    "price-calculator-customer-or-booking-box",
  priceCalculatorCustomerSearchField: "price-calculator-customer-search-field",
  priceCalculatorBookingSearchField: "price-calculator-booking-search-field",
  priceCalculatorConsignmentVersionBox:
    "price-calculator-consignment-version-box",
  priceCalculatorMovementTypeSelection:
    "price-calculator-movement-type-selection",
  priceCalculatorSectionalRouteSelect:
    "price-calculator-sectional-route-select",
  priceCalculatorSectionalTimetableSelect:
    "price-calculator-sectional-timetable-select",
  priceCalculatorSectionalSailingCategorySelect:
    "price-calculator-sectional-sailing-category-select",
  priceCalculatorSectionalDepartureTimeInput:
    "price-calculator-sectional-departure-time-input",
  priceCalculatorMultilegRouteSelect: "price-calculator-multileg-route-select",
  priceCalculatorMultilegVehicleTypeSelect:
    "price-calculator-vehicle-type-select",
  priceCalculatorCalculatePriceButton:
    "price-calculator-calculate-price-button",
  priceCalculatorResultTripInformation:
    "price-calculator-result-trip-information",
  priceCalculatorResultVehicleType: "price-calculator-result-vehicle-type",
  priceCalculatorResultPriceTripInformation:
    "price-calculator-result-price-trip-information",
  priceCalculatorResultPriceVehicleInformation:
    "price-calculator-result-price-vehicle-information",
  priceCalculatorResultPriceLegBox: "price-calculator-result-price-leg-box",
  priceCalculatorResultPriceTable: "price-calculator-result-price-table",
  priceCalculatorCalculateChangeCustomerButton:
    "price-calculator-change-customer-button",
  headerAgreementActionsMenu: "header-agreement-actions-menu",
  headerAgreementActionsMenuCopyAgreement:
    "header-agreement-actions-menu-copy-agreement",
  headerAgreementActionsMenuCopyToOtherCustomer:
    "header-agreement-actions-menu-copy-to-other-customer",
  headerAgreementActionsMenuCopyFromOtherCustomer:
    "header-agreement-actions-menu-copy-from-other-customer",
  headerAgreementActionsMenuEditAgreement:
    "header-agreement-actions-menu-edit-agreement",
  headerAgreementActionsMenuNewAgreement:
    "header-agreement-actions-menu-new-agreement",
  headerAgreementActionsMenuAgreementArticles:
    "header-agreement-actions-menu-agreement-articles",
  headerAgreementActionsMenuCreateOffer:
    "header-agreement-actions-menu-create-offer",
  headerAgreementActionsMenuCreateConfirmation:
    "header-agreement-actions-menu-create-confirmation",
  headerAgreementActionsMenuSetToPending:
    "header-agreement-actions-menu-set-to-pending",
  headerAgreementActionsMenuActivate: "header-agreement-actions-menu-activate",
  headerAgreementActionsMenuSetToVoid:
    "header-agreement-actions-menu-set-to-void",
  headerAgreementActionsMenuDelete: "header-agreement-actions-menu-delete",
  headerAgreementEditRatesButton: "header-agreement-edit-rates-button",
  headerAgreementDocumentsButton: "header-agreement-documents-button",
  headerAgreementNegotiationStatus: "header-agreement-negotiation-status",
  headerAgreementHAInfoBox: "header-agreement-ha-info-box",
  headerAgreementRouteAgreementsTable:
    "header-agreement-route-agreements-table",
  headerAgreementExpandAllButton: "header-agreement-expand-all-button",
  bulkEditRatesFilterButton: "bulk-edit-rates-filter-button",
  bulkEditRatesSaveButton: "bulk-edit-rates-save-button",
  bulkEditRatesRaiseRateByInput: "bulk-edit-rates-raise-rate-by-input",
  bulkEditRatesActionsPanelApplyButton:
    "bulk-edit-rates-actions-panel-apply-button",
  nameInput: "name-input",
  validityInput: "validity-input",
  createHeaderAgreementCreateButton: "create-header-agreement-create-button",
  createHeaderAgreementCancelButton: "create-header-agreement-cancel-button",
  agreementReportSpecificationsArea: "agreement-report-specification-area",
  agreementReportConditionArea: "agreement-report-condition-area",
  agreementReportLastPageArea: "agreement-report-last-page-area",
  InternalNotes: "internal-notes",
  deleteHeaderAgreementModalYesButton:
    "delete-header-agreement-modal-yes-button",
  editHeaderAgreementSaveAgreementButton:
    "edit-header-agreement-save-agreement-button",
  editHeaderAgreementCancelButton: "edit-header-agreement-cancel-button",
  newRouteAgreementButton: "new-route-agreement-button",
  createRouteAgreementModalCancelButton:
    "create-route-agreement-modal-cancel-button",
  createRouteAgreementModalCreateAgreementButton:
    "create-route-agreement-modal-create-agreement-button",
  errorMessageText: "error-message-text",
  createRouteAgreementSailingCategoryPeak:
    "create-route-agreement-sailing-category-peak",
  createRouteAgreementSailingCategoryOffpeak:
    "create-route-agreement-sailing-category-offpeak",
  createRouteAgreementSailingCategoryShoulder:
    "create-route-agreement-sailing-category-shoulder",
  createRouteAgreementCurrencySelector:
    "create-route-agreement-currency-selector",
  createRouteAgreementSelectRoute: "create-route-agreement-select-route",
  createRouteAgreementNameTextBox: "create-route-agreement-name-text-box",
  breadcrumbCustomer: "breadcrumb-customer",
  breadcrumbHeaderAgreement: "breadcrumb-header-agreement",
  routeAgreementRatesTab: "route-agreement-rates-tab",
  routeAgreementRoutesTab: "route-agreement-routes-tab",
  createRouteRatesAddVehicleType: "create-route-rates-add-vehicle-type",
  createRouteRatesAddVehicleAddButton:
    "create-route-rates-add-vehicle-add-button",
  createRouteRatesSelectVehicleType:
    "create-route-rates-select-vehicle-add-button",
  createRouteRatesRecalculateStatistics:
    "create-route-rates-recalculate-statistics",
  routeAgreementSaveButton: "route-agreement-save-button",
  createRouteRatesAddVehicleTypeSelect:
    "create-route-rates-add-vehicle-type-select",
  createRouteRatesAddVehicleLengthFrom: "create-route-rates-length-from",
  createRouteRatesAddVehicleLengthTo: "create-route-rates-length-to",
  createRouteRatesAddVehicleWeightFrom: "create-route-rates-weight-from",
  createRouteRatesAddVehicleWeightTo: "create-route-rates-weight-to",
  createRouteRatesErrorBanner: "create-route-rates-error-banner",
  routeRatesToAgreementButton: "route-rates-to-agreement-button",
  routeAgreementDiscardButton: "route-agreement-discard-button",
  groupFreightTargetsSaveButton: "group-freight-targets-save-button",
  groupFreightTargetsDiscardButton: "group-freight-targets-discard-button",
  nSLHRoutePricesDiscardButton: "n-s-l-h-route-prices-discard-button",
  nSLHRoutePricesSaveButton: "n-s-l-h-route-prices-save-button",
  nSLHFollowUpOverviewInfoBox: "n-s-l-h-follow-up-overview-info-box",
  routePriceAddNewValidFromDateYearSelect:
    "route-price-add-new-valid-from-date-year-select",
  routePriceIncludePriceRadioButton: "route-price-include-price-radio-button",
  routePriceDoNotIncludePriceRadioButton:
    "route-price-do-not-include-price-radio-button",
  routePriceAddNewValidFromDateConfirmButton:
    "route-price-add-new-valid-from-date-button-confirm",
  routePriceDeleteNewValidFromDateConfirmButton:
    "route-price-delete-new-valid-from-date-button-confirm",
  vehicleTypeFilterSection: "vehicle-type-filter-section",
  vehicleTypeFilterSectionTypeAllCheckbox:
    "vehicle-type-filter-section-type-all-checkbox",
  rebateFilterButton: "rebate-filter-button",
  rebateFilterClearButton: "rebate-filter-clear-button",
  rebateFilterSectionYear: "rebate-filter-section-year",
  rebateFilterSectionAgreementNumber: "rebate-filter-section-agreement-number",
  rebateFilterSectionValidityDates: "rebate-filter-section-validity-dates",
  rebateFilterSectionBookingCustomer: "rebate-filter-section-booking-customer",
  rebateFilterSectionSeller: "rebate-filter-section-seller",
  rebateFilterSectionSalesRegions: "rebate-filter-section-sales-regions",
  rebateFilterSectionTerm: "rebate-filter-section-term",
  rebateFilterSectionGoalStatus: "rebate-filter-section-goal-status",
  rebateFilterAgreementNumberInput: "rebate-filter-agreement-number-input",
  menuLinkRebates: "menu-link-rebates",
  menuLinkRebatesHandle: "menu-link-rebates-handle",
  menuLinkRebatesFollowUp: "menu-link-rebates-follow-up",
  rebateFollowUpTable: "rebate-follow-up-table",
  rebateFollowUpOpenFilterButton: "rebate-follow-up-open-filter-button",
  rebateFollowUpActionMenuButton: "rebate-follow-up-action-menu-button",
  rebateFollowUpActionMenuChangeExpectedVolume:
    "rebate-follow-up-action-menu-change-expected-volume",
  expectedVolumeModal: "expected-volume-modal",
  expectedVolumeModalCurrentValue: "expected-volume-modal-current-value",
  expectedVolumeModalSuggestedValue: "expected-volume-modal-suggested-value",
  expectedVolumeModalNewExpectedVolumeInput:
    "expected-volume-modal-new-expected-volume-input",
  expectedVolumeModalUseSuggestedCheckbox:
    "expected-volume-modal-use-suggested-checkbox",
  expectedVolumeModalCloseButton: "expected-volume-modal-close-button",
  expectedVolumeModalSaveButton: "expected-volume-modal-save-button",
  handleRebatesTable: "handle-rebates-table",
  handleRebatesOpenFilterButton: "handle-rebates-open-filter-button",
  handleRebatesActionMenuButton: "handle-rebates-action-menu-button",
  handleRebatesActionMenuPayOut: "handle-rebates-action-menu-pay-out",
  handleRebatesActionMenuRelease: "handle-rebates-action-menu-release",
  handleRebatesActionMenuAuthorizePayment:
    "handle-rebates-action-menu-authorize-payment",
  handleRebatesActionMenuPayOutOnHigherLevel:
    "handle-rebates-action-menu-pay-out-on-higher-level",
  handleRebatesActionMenuShowSummary: "handle-rebates-action-menu-show-summary",
  handleRebatesActionMenuShowBookings:
    "handle-rebates-action-menu-show-bookings",
  handleRebatesTableReservedCell: "handle-rebates-table-reserved-cell",
  handleRebatesTablePaidCell: "handle-rebates-table-paid-cell",
  handleRebatesSummaryDrawer: "handle-rebates-summary-drawer",
  handleRebatesSummaryDrawerReservedValue:
    "handle-rebates-summary-drawer-reserved-value",
  handleRebateModal: "handle-rebate-modal",
  handleRebateModalReservedValue: "handle-rebate-modal-reserved-value",
  handleRebateModalAmountToPayInput: "handle-rebate-modal-amount-to-pay-input",
  handleRebateModalAmountToReleaseInput:
    "handle-rebate-modal-amount-to-release-input",
  handleRebateModalCustomerReferenceInput:
    "handle-rebate-modal-customer-reference-input",
  handleRebateModalCustomerReferenceCounter:
    "handle-rebate-modal-customer-reference-counter",
  handleRebateModalManualPricingCheckbox:
    "handle-rebate-modal-manual-pricing-checkbox",
  handleRebateModalCloseButton: "handle-rebate-modal-close-button",
  handleRebateModalSubmitButton: "handle-rebate-modal-submit-button",
  authorizePayoutModal: "authorize-payout-modal",
  authorizePayoutModalReservedValue: "authorize-payout-modal-reserved-value",
  authorizePayoutModalCloseButton: "authorize-payout-modal-close-button",
  authorizePayoutModalAuthorizeButton:
    "authorize-payout-modal-authorize-button",
  rebateBookingsBreadcrumbHandleRebates:
    "rebate-bookings-breadcrumb-handle-rebates",
  rebateBookingsCopyButton: "rebate-bookings-copy-button",
  rebateBookingsExportButton: "rebate-bookings-export-button",
  /** Suffixed with the route code, so each route card has its own id. */
  rebateBookingsRouteCard: "rebate-bookings-route-card",
  /** Suffixed with the route code, as above. */
  rebateBookingsRouteTable: "rebate-bookings-route-table",
  nSLHHandleBookingsFilterButton: "n-s-l-h-handle-bookings-filter-button",
  nslhPageHeader: "NSLHHFollowUpHeader",
  searchInvoiceSpecificationsButton: "searchInvoiceSpecifications",
  noInvoicesBanner: "invoices_empty_list_banner",
  documentsViewTabs: "document-view-tabs",
  priceCalculatorPriceDetailsButton: "price-calculator-price-details-button",
  priceCalculatorAuditTrackButton: "price-calculator-audit-track-button",
  createReportForParentButton: "create-report-for-parent-button",
  wizardHeader: "wizard-header",
  pricelistMenuButton: "pricelist-menu-button",
};
